import { useMemo } from 'react';
import { useAuth } from '../contexts/AuthContext';
import {
  getOperationConfig,
  hasFeature,
  getMenus,
  getDashboardWidgets,
  getRecommendedPlan,
  getFilteredMenus
} from '../config/features';

/**
 * operationType 기반 기능 설정 훅
 *
 * 사용법:
 * const { hasFeature, menus, widgets, config } = useFeatures();
 *
 * if (hasFeature('teacherManagement')) {
 *   // 강사 관리 기능 표시
 * }
 */
export function useFeatures() {
  const { tenant } = useAuth();

  // operationType 가져오기 (기본값: 'solo')
  const operationType = tenant?.operationType || 'solo';

  // 전체 설정 객체
  const config = useMemo(
    () => getOperationConfig(operationType),
    [operationType]
  );

  // 수업일지 작성 주기 설정
  const frequencies = tenant?.lessonReportConfig?.frequencies || ['daily'];

  // 메뉴 목록 (작성 주기에 따라 필터링)
  const menus = useMemo(
    () => getFilteredMenus(operationType, frequencies),
    [operationType, frequencies]
  );

  // 대시보드 위젯 목록
  const widgets = useMemo(
    () => getDashboardWidgets(operationType),
    [operationType]
  );

  // 추천 플랜 정보
  const recommendedPlan = useMemo(
    () => getRecommendedPlan(operationType),
    [operationType]
  );

  // 특정 기능 사용 가능 여부 체크 함수
  const checkFeature = (featureName) => {
    return hasFeature(operationType, featureName);
  };

  return {
    operationType,
    config,
    menus,
    widgets,
    recommendedPlan,
    hasFeature: checkFeature,

    // 편의를 위한 개별 feature 플래그
    features: config.features
  };
}

export default useFeatures;
